import ReportsScreen from './ReportsScreen';

export default ReportsScreen;
